import { ReactElement } from 'react';

import { IconSvg, IconSvgProps, Text } from '@/lib/v2/components';

interface TitleHeadCellProps {
  text: string;
  icon?: ReactElement<IconSvgProps>;
}
const TitleHeadCell = ({ text, icon }: TitleHeadCellProps) => {
  return (
    <>
      {icon && <IconSvg height="16px" svgComponent={icon} width="16px" />}
      <Text color="primary" fontWeight="medium" variant="text">
        {text}
      </Text>
    </>
  );
};

export default TitleHeadCell;
